module.exports = __webpack_public_path__ + "img/new.ff47be87.png";